import React, { useState } from 'react'

import { CtaButton, Image } from '..'
import LinkComponent from '../LinkComponent/LinkComponent'
import richTextRenderer from '../RichTextParser/RichTextParser'
import { Kicker } from '../Typography'
import {
  blogImageStyling,
  contentCard,
  contentCardFooter,
  contentStyling,
  divider,
  doctorsContent,
  doctorsImg,
  heightAuto,
  imageStyling,
  priceStyling,
  setHeight,
  stepContentContainer,
  stepsOpened,
  titleStyling,
  toReadMoreContainer,
  withCtaFooter,
} from './LinkCardComponent.module.css'

const Wrapper = ({
  children,
  cta,
  extraClassName,
  readmoreCta,
  url,
  urlTarget,
}) =>
  url ? (
    <LinkComponent
      className={`${contentCard} ${
        cta && !readmoreCta ? heightAuto : ''
      } ${extraClassName}`}
      src={urlTarget}
    >
      {children}
    </LinkComponent>
  ) : (
    <div
      className={`${contentCard} ${
        cta && !readmoreCta ? heightAuto : ''
      } ${extraClassName}`}
    >
      {children}
    </div>
  )

const JustifiedLinkCard = ({
  blogImage,
  content,
  cta,
  customContent,
  doctors,
  extraClassName,
  extraContentCardStyle,
  heading,
  image,
  kicker,
  price,
  readmoreCta,
  setImageHeight,
  title,
  url = false,
  urlTarget,
}) => {
  const [open, setOpen] = useState(false)
  let ctaButton = cta
  if (typeof cta === 'string') {
    ctaButton = JSON.parse(cta)
  }

  return (
    <Wrapper
      cta={cta}
      extraClassName={extraClassName}
      readmoreCta={readmoreCta}
      url={url}
      urlTarget={urlTarget}
    >
      {image && (
        <Image
          alt={image.altText || 'Kliniken Image'}
          className={`${imageStyling} ${doctors ? doctorsImg : ''} ${
            setImageHeight ? setHeight : ''
          }`}
          placeholder="none"
          src={image.node.localFile.childImageSharp}
        />
      )}
      {blogImage && (
        <Image
          alt={blogImage.altText || 'Kliniken Image'}
          className={`${blogImageStyling}`}
          placeholder="none"
          src={blogImage.node.localFile.childImageSharp}
        />
      )}{' '}
      <div
        className={`${contentCardFooter} ${
          cta ? withCtaFooter : ''
        } ${extraContentCardStyle}`}
      >
        {kicker && <Kicker>{kicker}</Kicker>}
        {title && !doctors && <h3 className={titleStyling}>{title}</h3>}
        {heading && <h3 className={titleStyling}>{heading}</h3>}
        {content && (
          <div
            className={`${doctors ? doctorsContent : contentStyling} ${
              customContent ? stepContentContainer : ''
            } ${
              customContent && customContent.length > 500
                ? toReadMoreContainer
                : ''
            } ${open ? stepsOpened : ''}`}
          >
            {richTextRenderer(customContent || content)}
          </div>
        )}
        {title && doctors && <h3 className={titleStyling}>{title}</h3>}
        {cta && readmoreCta && customContent && customContent.length > 500 && (
          <CtaButton
            onClick={() => setOpen(!open)}
            title={ctaButton.title}
            type={ctaButton.type}
          />
        )}
        {cta && !readmoreCta && (
          <CtaButton {...ctaButton} cardWrappedwithLink />
        )}
        {price && (
          <div>
            <div className={divider} />
            <div className={`${titleStyling} ${priceStyling}`}>
              {richTextRenderer(price)}
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  )
}

export default JustifiedLinkCard
